import { apiRequest } from '@/shared/api/client'

export interface PublicSportType {
  id: string
  code: string
  name: string
  icon_svg_url?: string
  icon_png_url?: string
  /** BAT-1064: sport is offered to individual athletes (catalog flag). */
  available_for_athletes?: boolean
  available_for_clubs?: boolean
}

interface SportTypesResponse {
  sport_types?: PublicSportType[]
}

// BAT-1110: 'athletes' — the ACTIVE sports available to athletes (BAT-1103).
// BAT-1211: 'athletes_leaderboard' — those plus the sports of the athletes on
// the board (a sport switched off for athletes keeps its athletes).
export type SportTypesScope =
  | 'requestable'
  | 'athletes'
  | 'athletes_leaderboard'
  | 'clubs'

export async function getSportTypes(
  scope?: SportTypesScope
): Promise<PublicSportType[]> {
  const response = await apiRequest<SportTypesResponse>({
    path: '/api/v2/sport-types',
    method: 'GET',
    ...(scope ? { query: { scope } } : {}),
    format: 'json'
  })

  return response.sport_types ?? []
}
